import { render, staticRenderFns } from "./DashboardIaAnalyzer.vue?vue&type=template&id=07bcae08&scoped=true"
import script from "./DashboardIaAnalyzer.vue?vue&type=script&lang=js"
export * from "./DashboardIaAnalyzer.vue?vue&type=script&lang=js"
import style0 from "./DashboardIaAnalyzer.vue?vue&type=style&index=0&id=07bcae08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcae08",
  null
  
)

export default component.exports